import { Routes } from '@angular/router';
import { BuyerActiveAuctionsComponent } from './pages/buyer-active-auctions/buyer-active-auctions.component';
import { BuyerUpcomingAuctionsComponent } from './pages/buyer-upcoming-auctions/buyer-upcoming-auctions.component';
import { BuyerPreviousAuctionsComponent } from './pages/buyer-previous-auctions/buyer-previous-auctions.component';
import { BuyerCatalogueComponent } from './pages/buyer-catalogue/buyer-catalogue.component';
import { HorseViewPageComponent } from './pages/horse-view-page/horse-view-page.component';
import { AuctionsListComponent } from './pages/auctions-list/auctions-list.component';
import { seoResolverResolver } from 'src/app/Core/_resolvers/seo-resolver.resolver';

export const ROUTES: Routes = [
  {
    path: 'active',
    component: BuyerActiveAuctionsComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'Active Horse Auctions | BidxSell',
      description:
        'Browse currently active horse auctions on BidxSell. Place bids on premium horses, thoroughbreds, and racing stock from top sellers.',
    },
  },
  {
    path: 'upcoming',
    component: BuyerUpcomingAuctionsComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'Upcoming Horse Auctions | BidxSell',
      description:
        'Discover upcoming horse auctions on BidxSell. Preview lots, register for auctions, and prepare for exclusive horse sales.',
    },
  },

  {
    path: 'previous',
    component: BuyerPreviousAuctionsComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'Previous Horse Auctions | BidxSell',
      description:
        'View results from previous horse auctions on BidxSell. See sale prices, winning bids, and auction history.',
    },
  },
  {
    path: 'list/all',
    component: AuctionsListComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'All Horse Auctions | BidxSell',
      description:
        'Browse all horse auctions on BidxSell. View active, upcoming, and previous auctions in one comprehensive list.',
    },
  },
  {
    path: ':slug',
    component: BuyerCatalogueComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'Auction Catalogue | BidxSell',
      description:
        'Browse horses in this exclusive auction. View detailed profiles, bidding information, and lot details.',
    },
  },

  {
    path: 'id/:auction_id',
    component: BuyerCatalogueComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'Auction Catalogue | BidxSell',
      description:
        'Browse horses in this exclusive auction. View detailed profiles, bidding information, and lot details.',
    },
  },

  {
    path: ':auctionSlug/horse/:slug',
    component: HorseViewPageComponent,
    resolve: { seo: seoResolverResolver },
    data: {
      title: 'Horse View | BidxSell',
      description:
        'View detailed horse information, bidding details, pedigree, and high-quality photos.',
    },
  },

  { path: '', pathMatch: 'full', redirectTo: 'list/all' },
];
